/**
 * Quote-aware argument tokenizer — splits a command line on whitespace
 * while keeping `"double-quoted"` segments intact. Used by DYNSET so
 * parameter names with spaces (e.g. `"Состояние видимости"`) and
 * values with spaces (`"Без выноски"`) survive the split.
 *
 * AutoCAD's command line accepts matching double-quotes; a backslash
 * inside a quoted segment escapes the following character so `\"` is a
 * literal double quote. Single quotes are NOT special (AutoCAD's object
 * snap transparent command prefix uses `'`, which is why we cannot
 * repurpose it as a string delimiter).
 *
 * Examples:
 *   `Length 1500`                   → ["Length", "1500"]
 *   `"Состояние видимости" Open`    → ["Состояние видимости", "Open"]
 *   `"With \"quotes\"" trailing`    → [`With "quotes"`, "trailing"]
 *   ``                              → []
 */
export function tokenize(line: string): string[] {
  const tokens: string[] = [];
  let buf = "";
  let inQuote = false;
  let hasChar = false;
  let i = 0;
  while (i < line.length) {
    const ch = line[i]!;
    if (inQuote) {
      if (ch === "\\" && i + 1 < line.length) {
        buf += line[i + 1]!;
        i += 2;
        hasChar = true;
        continue;
      }
      if (ch === '"') {
        inQuote = false;
        i += 1;
        continue;
      }
      buf += ch;
      hasChar = true;
      i += 1;
      continue;
    }
    if (ch === '"') {
      inQuote = true;
      hasChar = true;
      i += 1;
      continue;
    }
    if (/\s/u.test(ch)) {
      if (hasChar) {
        tokens.push(buf);
        buf = "";
        hasChar = false;
      }
      i += 1;
      continue;
    }
    buf += ch;
    hasChar = true;
    i += 1;
  }
  if (hasChar) tokens.push(buf);
  return tokens;
}
